import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';

import { OverlayPanel, OverlayPanelModule } from 'primeng/overlaypanel';
import { Road } from '../../../modules/select-road/models/select-road.model';
import { mapDirectionCode } from '../../utils/road-directions-mapper';


@Component({
  selector: 'road-info-panel',
  standalone: true,
  imports: [CommonModule, OverlayPanelModule],
  templateUrl: './road-info-panel.component.html',
})
export class RoadInfoPanelComponent implements OnInit {

  @Input() road: Road | null = null;
  @Input() roles: string[] = [];
  @ViewChild('roadInfoPanel') overlayPanel!: OverlayPanel;

  constructor() {}

  ngOnInit(): void {}

  open(event: Event) {
    if (!this.road) return;
    if (!this.roles) this.roles = [];

    this.overlayPanel.toggle(event);
  }

  mapDirectionCodeToText(code: string): string {
    return mapDirectionCode(code);
  }

  getRoleLabel(role: string): string {
    if (role === 'admin') {
      return 'admin';
    }

    if (role === 'coordinador' || role.startsWith('coordinador_')) {
      return this.formatScopedRoleLabel(role, 'coordinador');
    }

    if (role === 'operador' || role.startsWith('operador_')) {
      return this.formatScopedRoleLabel(role, 'operador');
    }

    return role.replace(/_/g, ' ');
  }

  getRoleBadgeClasses(role: string): string {
    if (role === 'admin') {
      return 'bg-red-100 text-red-700';
    }

    if (role === 'coordinador' || role.startsWith('coordinador_')) {
      return 'bg-blue-100 text-blue-700';
    }

    if (role === 'operador' || role.startsWith('operador_')) {
      return 'bg-green-100 text-green-700';
    }

    return 'bg-gray-100 text-gray-700';
  }

  private formatScopedRoleLabel(role: string, baseRole: string): string {
    if (role === baseRole) {
      return baseRole;
    }

    const scope = role.slice(baseRole.length + 1).replace(/_/g, ' ').trim();
    return scope ? `${baseRole} ${scope}` : baseRole;
  }

}
